import React, { useState, useEffect } from 'react';
import api from '../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../components/ui/dialog';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { toast } from 'sonner';
import { Plus, Edit, Trash2, Users } from 'lucide-react';
import { Badge } from '../components/ui/badge';

const Empleados = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [formData, setFormData] = useState({
    nombre_completo: '',
    cedula: '',
    telefono: '',
    direccion: '',
    tipo: 'recolector',
    salario_base: 0,
    metodo_pago: 'cash'
  });

  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    try {
      const response = await api.get('/employees');
      setEmployees(response.data.data || []);
    } catch (error) {
      toast.error('Error al cargar empleados');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/employees', formData);
      toast.success('Empleado creado');
      fetchEmployees();
      setDialogOpen(false);
      resetForm();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error');
    }
  };

  const resetForm = () => {
    setFormData({ nombre_completo: '', cedula: '', telefono: '', direccion: '', tipo: 'recolector', salario_base: 0, metodo_pago: 'cash' });
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6 pb-24">
      <div className="max-w-7xl mx-auto">
        <Card>
          <CardHeader>
            <div className="flex items-center justify-between">
              <CardTitle className="text-2xl flex items-center"><Users className="mr-2" />Empleados</CardTitle>
              <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
                <DialogTrigger asChild>
                  <Button onClick={resetForm}><Plus className="mr-2 h-4 w-4" />Nuevo Empleado</Button>
                </DialogTrigger>
                <DialogContent className="max-w-xl">
                  <DialogHeader><DialogTitle>Nuevo Empleado</DialogTitle></DialogHeader>
                  <form onSubmit={handleSubmit} className="space-y-4">
                    <div><Label>Nombre Completo *</Label><Input value={formData.nombre_completo} onChange={(e) => setFormData({...formData, nombre_completo: e.target.value})} required /></div>
                    <div><Label>Cédula *</Label><Input value={formData.cedula} onChange={(e) => setFormData({...formData, cedula: e.target.value})} required /></div>
                    <div><Label>Teléfono *</Label><Input value={formData.telefono} onChange={(e) => setFormData({...formData, telefono: e.target.value})} required /></div>
                    <div><Label>Dirección *</Label><Input value={formData.direccion} onChange={(e) => setFormData({...formData, direccion: e.target.value})} required /></div>
                    <div><Label>Tipo</Label>
                      <Select value={formData.tipo} onValueChange={(value) => setFormData({...formData, tipo: value})}>
                        <SelectTrigger><SelectValue /></SelectTrigger>
                        <SelectContent>
                          <SelectItem value="recolector">Recolector</SelectItem>
                          <SelectItem value="repartidor">Repartidor</SelectItem>
                          <SelectItem value="contador">Contador</SelectItem>
                          <SelectItem value="admin">Admin</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                    <div><Label>Salario Base</Label><Input type="number" step="0.01" value={formData.salario_base} onChange={(e) => setFormData({...formData, salario_base: parseFloat(e.target.value) || 0})} /></div>
                    <div className="flex justify-end space-x-2">
                      <Button type="button" variant="outline" onClick={() => setDialogOpen(false)}>Cancelar</Button>
                      <Button type="submit">Crear</Button>
                    </div>
                  </form>
                </DialogContent>
              </Dialog>
            </div>
          </CardHeader>
          <CardContent>
            {loading ? <div className="text-center py-8">Cargando...</div> : (
              <Table>
                <TableHeader>
                  <TableRow><TableHead>Nombre</TableHead><TableHead>Cédula</TableHead><TableHead>Teléfono</TableHead><TableHead>Tipo</TableHead><TableHead>Salario</TableHead></TableRow>
                </TableHeader>
                <TableBody>
                  {employees.length === 0 ? <TableRow><TableCell colSpan={5} className="text-center text-gray-500">No hay empleados</TableCell></TableRow> : employees.map((emp) => (
                    <TableRow key={emp.id}>
                      <TableCell className="font-medium">{emp.nombre_completo}</TableCell>
                      <TableCell>{emp.cedula}</TableCell>
                      <TableCell>{emp.telefono}</TableCell>
                      <TableCell><Badge>{emp.tipo}</Badge></TableCell>
                      <TableCell>${emp.salario_base?.toFixed(2)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Empleados;
